import { usePage } from '@/hooks'
import {
  GxTab,
  GxTabGroup,
  GxTabPanel
} from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/auth.module.scss'
import AuthorizationForm from './components/AuthorizationForm'
import RegistrationForm from './components/RegistrationForm'

const AuthorizationApp = (): React.ReactElement => {
  const page = usePage()

  const { config } = page?.init_state?.global

  return (
    <GxTabGroup noScrollControls className={style.tab}>
      <GxTab slot='nav' panel='auth' className={style.tab__button}>
        Вход
      </GxTab>
      <GxTab slot='nav' panel='reg' className={style.tab__button}>
        Регистрация
      </GxTab>

      <GxTabPanel name='auth' className={style.tab__panel}>
        <AuthorizationForm
          redirectPage={config.profile}
          forgotPasswordUrl={config.forgot_your_password}
        />
      </GxTabPanel>
      <GxTabPanel name='reg' className={style.tab__panel}>
        <RegistrationForm redirectPage={config.profile} />
      </GxTabPanel>
    </GxTabGroup>
  )
}

export default AuthorizationApp
